import { render, staticRenderFns } from "./category-badge.vue?vue&type=template&id=6a507ef0"
import script from "./category-badge.vue?vue&type=script&lang=js"
export * from "./category-badge.vue?vue&type=script&lang=js"
import style0 from "./category-badge.vue?vue&type=style&index=0&id=6a507ef0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports